class ThemeUtils {
  static globalColors = {
    white: "255,255,255",
    black: "0,0,0",
  };
}

export default ThemeUtils;
